import React, { useState } from "react";
import { _Api } from "../../api/_call";
import { error } from "../../common/helpers/toastify";
import { useTranslation } from "react-i18next";

const EditColumnSubmenu = (props) => {
  const { t } = useTranslation();
  const { tablehead, tblName, setnewcolumndata, calldatatable } = props;
  const [newcolumndata_, setnewcolumndata_] = useState(tablehead);



  const userSelectedAnswer = (Qindex) => {
    let newcolumndata_data = [...newcolumndata_];
    var check_checked = document.querySelector("#tableth" + Qindex).checked;
    newcolumndata_data[Qindex].status = check_checked;
    setnewcolumndata_(newcolumndata_data);


    const postdata = {
      name: tblName,
      data: newcolumndata_data,
    };
    _Api(postdata, `api/v1/Inventory/common/saveColumnHead`)
      .then((resPoOrders) => {
        if (resPoOrders.code === 200) {
          setnewcolumndata(newcolumndata_data);
          calldatatable();
        } else {
          error(resPoOrders.errors);
        }
      })
      .catch((err) => {
        console.log(err, "err");
      });
  };

  return (
    <>
      <ul className="edit-columns-dropdown-menu">
        <div className="edit-columns-dropdown-menu-submenu fixed-columns-submenu">
          <p className="edit-columns-dropdown-menu-submenu-heading">
            {t("Fixed Columns")}
          </p>
          {newcolumndata_?.map((result, key) =>
            key < 4 ? (
              <div key={key} className="column-list-checkbox-area-check">
                <div className="com-check">
                  <input
                    onChange={() => userSelectedAnswer(key)} // Trigger update on change
                    id={"tableth" + key}
                    checked={result?.status}
                    type="checkbox"
                    disabled
                  />
                  <label
                    htmlFor={"tableth" + key}
                    className="com-check-label"
                  />
                </div>
                <label
                  htmlFor={"tableth" + key}
                  className="label-edit-column-item"
                >
                  {result?.name ? t(result?.name) : "columnname"}
                </label>
              </div>
            ) : null
          )}
        </div>

        <div className="edit-columns-dropdown-menu-submenu">
          <p className="edit-columns-dropdown-menu-submenu-heading">
            {t("Active Columns")}
          </p>
          {newcolumndata_?.map((result, key) => {
            return (key >= 4 && key < 14) ? (
              <div key={key} className="column-list-checkbox-area-check">
                <div className="com-check">
                  <input
                    onChange={() => userSelectedAnswer(key)} // Trigger update on change
                    id={"tableth" + key}
                    checked={result?.status}
                    type="checkbox"
                  />
                  <label
                    htmlFor={"tableth" + key}
                    className="com-check-label"
                  />
                </div>
                <label
                  htmlFor={"tableth" + key}
                  className="label-edit-column-item"
                >
                  {result?.name ? t(result?.name) : "columnname"}
                </label>
                <svg
                  width="8"
                  height="14"
                  viewBox="0 0 8 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M3.29688 2.12875C3.29688 1.40313 2.66687 0.8125 1.89062 0.8125C1.11438 0.8125 0.484375 1.40313 0.484375 2.12875C0.484375 2.8555 1.11438 3.445 1.89062 3.445C2.66687 3.445 3.29688 2.8555 3.29688 2.12875ZM3.29688 11.8712C3.29688 11.1445 2.66687 10.555 1.89062 10.555C1.11438 10.555 0.484375 11.1445 0.484375 11.8712C0.484375 12.5969 1.11438 13.1875 1.89062 13.1875C2.66687 13.1875 3.29688 12.5969 3.29688 11.8712ZM1.89062 5.68375C2.66687 5.68375 3.29688 6.27438 3.29688 7C3.29688 7.72562 2.66687 8.31625 1.89062 8.31625C1.11438 8.31625 0.484375 7.72562 0.484375 7C0.484375 6.27438 1.11438 5.68375 1.89062 5.68375ZM7.51562 2.12875C7.51562 1.40313 6.88562 0.8125 6.10938 0.8125C5.33313 0.8125 4.70312 1.40313 4.70312 2.12875C4.70312 2.8555 5.33313 3.445 6.10938 3.445C6.88562 3.445 7.51562 2.8555 7.51562 2.12875ZM6.10938 10.555C6.88562 10.555 7.51562 11.1445 7.51562 11.8712C7.51562 12.5969 6.88562 13.1875 6.10938 13.1875C5.33313 13.1875 4.70312 12.5969 4.70312 11.8712C4.70312 11.1445 5.33313 10.555 6.10938 10.555ZM7.51562 7C7.51562 6.27438 6.88562 5.68375 6.10938 5.68375C5.33313 5.68375 4.70312 6.27438 4.70312 7C4.70312 7.72562 5.33313 8.31625 6.10938 8.31625C6.88562 8.31625 7.51562 7.72562 7.51562 7Z"
                    fill="#A4A4A4"
                  />
                </svg>
              </div>
            ) : null; // Return null for cases where key < 4
          })}
        </div>
      </ul>
    </>
  );
};

export default EditColumnSubmenu;
